import dayjs from 'dayjs';

export type PeriodFrequency = 'W' | 'M' | 'Q';

const QUARTER_MONTH_RANGES = ['Jan - Mar', 'Apr - Jun', 'Jul - Sep', 'Oct - Dec'] as const;

/** Formats a period start date for calendar / metric column headers. */
export function formatPeriodLabel(startDate: string, frequency: PeriodFrequency): string {
    const d = dayjs(startDate);
    switch (frequency) {
        case 'W': {
            const daysFromYearStart = d.diff(d.startOf('year'), 'day');
            const weekNum = Math.floor(daysFromYearStart / 7) + 1;
            return `W${weekNum} (${d.format('D MMM YYYY')})`;
        }
        case 'M':
            return d.format('MMM YYYY');
        case 'Q': {
            const quarterIndex = Math.floor(d.month() / 3);
            return `Q${quarterIndex + 1} (${QUARTER_MONTH_RANGES[quarterIndex]} ${d.year()})`;
        }
    }
}
